export const PAGE_CONTENT_MAX_WIDTH = 1200;
export const PAGE_CONTENT_MAX_WIDTH_NARROW = 700;
export const DESKTOP_HEADER_HEIGHT = 80;
export const PROMO_BAR_HEIGHT = 42;
export const MOBILE_HEADER_HEIGHT = 65;
export const HEADER_Z_INDEX = 2;
export const SIGNATURE_CANVAS_HEIGHT = 240;
